import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeftIcon } from 'lucide-react';
const PrivacyPage: React.FC = () => {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-5974">
      <Header data-id="element-5975" />
      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8" data-id="element-5976">
        <div className="max-w-4xl mx-auto" data-id="element-5977">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-6" data-id="element-5978">
            <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-5979" />
            Back to Home
          </Link>
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8" data-id="element-5980">
            <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5981">
              Privacy Policy
            </h1>
            <div className="prose prose-green max-w-none" data-id="element-5982">
              <p className="text-gray-600 mb-4" data-id="element-5983">
                Last Updated: January 1, 2025
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-5984">
                1. Introduction
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-5985">
                The Edo State Government ("we", "our", or "us") is committed to
                protecting your privacy. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use the Edo State E-Services Portal ("Portal").
              </p>
              <p className="text-gray-600 mb-4" data-id="element-5986">
                Please read this Privacy Policy carefully. By accessing or using
                the Portal, you acknowledge that you have read, understood, and
                agree to be bound by this Privacy Policy.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-5987">
                2. Information We Collect
              </h2>
              <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3" data-id="element-5988">
                2.1 Personal Information
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-5989">
                We may collect personal information that you provide directly to
                us, including but not limited to:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-5990">
                <li data-id="element-5991">Full name</li>
                <li data-id="element-5992">
                  Contact information (email address, phone number, residential
                  address)
                </li>
                <li data-id="element-5993">National identification numbers</li>
                <li data-id="element-5994">Date of birth</li>
                <li data-id="element-5995">Employment information</li>
                <li data-id="element-5996">Financial information (for payment processing)</li>
                <li data-id="element-5997">Any other information you choose to provide</li>
              </ul>
              <h3 className="text-lg font-medium text-gray-900 mt-6 mb-3" data-id="element-5998">
                2.2 Automatically Collected Information
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-5999">
                When you access or use the Portal, we may automatically collect
                certain information, including:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-6000">
                <li data-id="element-6001">
                  Device information (IP address, browser type, operating
                  system)
                </li>
                <li data-id="element-6002">
                  Usage details (pages visited, time spent on pages, navigation
                  paths)
                </li>
                <li data-id="element-6003">Location information</li>
                <li data-id="element-6004">Cookies and similar tracking technologies</li>
              </ul>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6005">
                3. How We Use Your Information
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6006">
                We may use the information we collect for various purposes,
                including:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-6007">
                <li data-id="element-6008">
                  Providing, maintaining, and improving the Portal and its
                  services
                </li>
                <li data-id="element-6009">Processing transactions and sending related information</li>
                <li data-id="element-6010">Verifying your identity and eligibility for services</li>
                <li data-id="element-6011">Responding to your inquiries and support requests</li>
                <li data-id="element-6012">
                  Sending administrative information, updates, and security
                  alerts
                </li>
                <li data-id="element-6013">Monitoring and analyzing usage patterns and trends</li>
                <li data-id="element-6014">
                  Protecting against fraudulent, unauthorized, or illegal
                  activity
                </li>
                <li data-id="element-6015">Complying with legal obligations</li>
              </ul>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6016">
                4. Information Sharing and Disclosure
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6017">
                We may share your information in the following circumstances:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-6018">
                <li data-id="element-6019">
                  With other government agencies to process your requests or
                  fulfill our legal obligations
                </li>
                <li data-id="element-6020">
                  With service providers who perform services on our behalf
                </li>
                <li data-id="element-6021">
                  To comply with applicable laws, regulations, or legal
                  processes
                </li>
                <li data-id="element-6022">
                  To protect the rights, property, or safety of the Edo State
                  Government, Portal users, or others
                </li>
                <li data-id="element-6023">
                  In connection with a governmental reorganization, merger, or
                  acquisition
                </li>
              </ul>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6024">
                5. Data Security
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6025">
                We implement appropriate technical and organizational measures
                to protect the security of your personal information. However,
                please note that no method of transmission over the internet or
                electronic storage is 100% secure, and we cannot guarantee
                absolute security.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6026">
                6. Data Retention
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6027">
                We will retain your personal information for as long as
                necessary to fulfill the purposes outlined in this Privacy
                Policy, unless a longer retention period is required or
                permitted by law.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6028">
                7. Your Rights
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6029">
                Depending on applicable laws, you may have certain rights
                regarding your personal information, including:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-6030">
                <li data-id="element-6031">The right to access your personal information</li>
                <li data-id="element-6032">
                  The right to correct inaccurate or incomplete information
                </li>
                <li data-id="element-6033">
                  The right to request deletion of your personal information
                </li>
                <li data-id="element-6034">
                  The right to restrict or object to processing of your personal
                  information
                </li>
                <li data-id="element-6035">The right to data portability</li>
              </ul>
              <p className="text-gray-600 mb-4" data-id="element-6036">
                To exercise these rights, please contact us using the
                information provided in the "Contact Us" section.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6037">
                8. Changes to This Privacy Policy
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6038">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or for other operational, legal, or
                regulatory reasons. We will notify you of any material changes
                by posting the updated Privacy Policy on this page with a new
                effective date.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6039">
                9. Contact Us
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6040">
                If you have any questions, concerns, or requests regarding this
                Privacy Policy or our privacy practices, please contact us at:
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6041">
                Edo State ICT Agency
                <br data-id="element-6042" />
                Government House Complex
                <br data-id="element-6043" />
                Benin City, Edo State
                <br data-id="element-6044" />
                Nigeria
                <br data-id="element-6045" />
                Email: privacy@edostate.gov.ng
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6046" />
    </div>;
};
export default PrivacyPage;